import { forwardRef } from 'react';
import { InputFormContainer } from '../form/input-form-section';

type InformationContainerProps = { message: React.ReactNode };

export const InformationContainer = forwardRef(
  (props: InformationContainerProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const { message } = props;
    return (
      <div ref={ref}>
        <InputFormContainer>
          <span className="py-2 text-center font-semibold">{message}</span>
        </InputFormContainer>
      </div>
    );
  },
);
